import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import AlertModal from './commonComponents/AlertModal';
import httpService  from '../api/httpService';
import { useAuth } from '../contexts/AuthContext';

function getStoredUser() {
  try {
    const stored = localStorage.getItem('userDetails');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

/** Keys that must not be toggled by Select All (ids, dates, audit fields). */
function isSetupMetadataKey(key) {
  const lower = key.toLowerCase();
  if (lower === 'type' || lower === 'countrycode') return true;
  if (lower === 'adddate' || lower === 'addedby' || lower === 'moddate' || lower === 'modby') return true;
  if (lower.endsWith('setupid')) return true;
  return false;
}

function resolveSetupId(details, ...idKeys) {
  for (const key of idKeys) {
    const val = details?.[key];
    const num = Number(val);
    if (Number.isFinite(num) && num > 0) return num;
  }
  if (details && typeof details === 'object') {
    for (const [key, val] of Object.entries(details)) {
      if (/setupid$/i.test(key)) {
        const num = Number(val);
        if (Number.isFinite(num) && num > 0) return num;
      }
    }
  }
  return null;
}

function sanitizeSetupPayload(details, { countryCode, addedBy, isUpdate } = {}) {
  const payload = { ...details };
  if (countryCode != null) payload.countryCode = countryCode;
  if (addedBy != null) payload.addedBy = addedBy;

  ['addDate', 'AddDate', 'modDate', 'ModDate', 'modBy', 'ModBy'].forEach((k) => {
    const v = payload[k];
    if (v === 0 || v === '0' || v == null || v === '') delete payload[k];
  });

  if (isUpdate) {
    delete payload.addDate;
    delete payload.AddDate;
    delete payload.modDate;
    delete payload.ModDate;
    delete payload.modBy;
    delete payload.ModBy;
  } else if (!payload.addDate && !payload.AddDate) {
    payload.addDate = new Date().toISOString();
  }

  return payload;
}

function Setting({ isEditing }) {

  const { countryId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const[isPageLoading, setIsPageLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const { userDetails } = useAuth();

  const [settingDetails, setSettingDetails] = useState({
    type: 1,
    totalNo: 0,
    genderMale: 0,
    genderFemale: 0,
    genderMissingUnknown: 0,
    ageAtAclrYearsMean: 0,
    ageAtAclrYearsLt15: 0,
    ageAtAclrYears1519: 0,
    ageAtAclrYears2024: 0,
    ageAtAclrYears2529: 0,
    ageAtAclrYears3034: 0,
    ageAtAclrYears3539: 0,
    ageAtAclrYearsGte40: 0,
    ageAtAclrYearsMissingUnknown: 0,
    bmiMean: 0,
    bmiLt25: 0,
    bmi2529: 0,
    bmiGte30: 0,
    bmiMissingUnknown: 0,
    raceAsian: 0,
    raceBlack: 0,
    raceHispanic: 0,
    raceWhite: 0,
    raceOther: 0,
    raceMissingUnknown: 0,
    asa12: 0,
    asaGte3: 0,
    asaMissingUnknown: 0,
    smokingNo: 0,
    smokingYes: 0,
    smokingMissingUnknown: 0,
    timeToAclr03wks: 0,
    timeToAclr3wks3mo: 0,
    timeToAclr3mo9mo: 0,
    timeToAclrGte9mo: 0,
    timeToAclrMissingUnknown: 0,
    operativeSideLeft: 0,
    operativeSideRight: 0,
    priorOperationNo: 0,
    priorOperationYes: 0,
    priorOperationMissingUnknown: 0,
    contralateralKneeNormalNo: 0,
    contralateralKneeNormalYes: 0,
    contralateralKneeNormalMissingUnknown: 0,
    infectionProphylaxisNo: 0,
    infectionProphylaxisYes: 0,
    thrombosisProphylaxisNo: 0,
    thrombosisProphylaxisYes: 0,
    operativeTimeMinutesMean: 0,
    operativeTimeMinutesMeanPercent: 0,
    operativeTimeMissingUnknown: 0,
  });

  const [type2Details, setType2Details] = useState({
    totalNo: 0,
    skiingSnowboarding: 0,
    altercation: 0,
    americanFootball: 0,
    rugby: 0,
    baseball: 0,
    basketball: 0,
    netball: 0,
    cycling: 0,
    danceGymnasticsCheer: 0,
    exercisingGym: 0,
    fall: 0,
    fieldHockeyLacrosse: 0,
    floorBall: 0,
    frisbee: 0,
    handball: 0,
    hikingJoggingRunningWalking: 0,
    horseRidingBullRiding: 0,
    iceHockeyBandy: 0,
    jumpingTrampoline: 0,
    martialArtsKampSportWrestling: 0,
    motorsportsMotorVehicleAccidentTraffic: 0,
    racquetSportsTennis: 0,
    rollerSkatingSkateboarding: 0,
    soccerFootball: 0,
    volleyball: 0,
    waterSports: 0,
    workInjury: 0,
    otherSpareTime: 0,
    other: 0,
    otherSport: 0,
    missingUnknown: 0
  });

  const [type3Details, setType3Details] = useState({
    totalNo: 0,
    multiLigamentInjuryNo: 0,
    multiLigamentInjuryYes: 0,
    mclTreatmentInjuryThatWasTreated: 0,
    mclTreatmentInjuryThatWasNotTreated: 0,
    mclInjuryTreatment: 0,
    lclTreatmentInjuryThatWasTreated: 0,
    lclTreatmentInjuryThatWasNotTreated: 0,
    lclTreatmentNoInjuryTreatment: 0,
    plcTreatmentInjuryThatWasTreated: 0,
    plcTreatmentInjuryThatWasNotTreated: 0,
    plcTreatmentNoInjuryTreatment: 0,
    pclTreatmentInjuryThatWasTreated: 0,
    pclTreatmentInjuryThatWasNotTreated: 0,
    pclTreatmentNoInjuryTreatment: 0,
    lateralMeniscusInjuryTreatment: 0,
    lateralMeniscusInjuryInjuryThatWasTreated: 0,
    lateralMeniscusInjuryInjuryThatWasNotTreated: 0,
    lateralMeniscusInjuryNoInjuryTreatment: 0,
    lateralMeniscusInjuryInjuryThatWasTreatedLeftSitu: 0,
    lateralMeniscusInjuryInjuryThatWasTreatedRasped: 0,
    lateralMeniscusInjuryInjuryThatWasTreatedRepair: 0,
    lateralMeniscusInjuryInjuryThatWasTreatedRepBio: 0,
    lateralMeniscusInjuryInjuryThatWasTreatedParMenis: 0,
    lateralMeniscusInjuryInjuryThatWasTreatedTrephinat: 0,
    medialMeniscusInjuryTreatment: 0,
    medialMeniscusInjuryInjuryThatWasTreated: 0,
    medialMeniscusInjuryInjuryThatWasNotTreated: 0,
    medialMeniscusInjuryInjuryThatWasTreatedLeftSitu: 0,
    medialMeniscusInjuryInjuryThatWasTreatedRasped: 0,
    medialMeniscusInjuryInjuryThatWasTreatedRepair: 0,
    medialMeniscusInjuryInjuryThatWasTreatedRepBio: 0,
    medialMeniscusInjuryInjuryThatWasTreatedParMenis: 0,
    medialMeniscusInjuryInjuryThatWasTreatedTrephinat: 0,
    medialMeniscusInjuryNoInjuryTreatment: 0,
    cartilageInjuryFromTrauma: 0,
    cartilageInjuryOsteoarthritis: 0,
    cartilageInjuryOther: 0,
    cartilageInjuryLocationPatella: 0,
    cartilageInjuryLocationLfc: 0,
    cartilageInjuryLocationLtp: 0,
    cartilageInjuryLocationMfc: 0,
    cartilageInjuryLocationMtp: 0,
    cartilageInjuryLocationTrochlea: 0,
    cartilageInjuryThatWasTreated: 0,
    typeOfTreatmentDebridment: 0,
    typeOfTreatmentMicrofracture: 0,
    typeOfTreatmentTransplant: 0,
    typeOfTreatmentMosaicplasty: 0,
    typeOfTreatmentAllograft: 0,
    typeOfTreatmentBiologicImplant: 0,
    typeOfTreatmentBiologicImplantName: 0,
    typeOfTreatmentOtherTypeOfTreatment: 0,
    cartilageInjuryThatWasNotTreated: 0,
    cartilageNoInjuryTreatment: 0
  });

  const [type4Details, setType4Details] = useState({
    totalNo: 0,
    graftSelectionAllograft: 0,
    graftSelectionPatellaTendonAutograft: 0,
    graftSelectionHamstringsTendonAtgraft: 0,
    graftSelectionHamstringsTendonAtgraftGracillis: 0,
    graftSelectionHamstringsTendonAtgraftSmiT: 0,
    graftSelectionHamstringsTendonAtgraftSmiTGracls: 0,
    graftSelectionQuadricepsTendonAtgraft: 0,
    graftSelectionHybridGraft: 0,
    graftSelectionSyntheticGraft: 0,
    graftSelectionOtherGraft: 0,
    graftSelectionSyntheticAugmentation: 0,
    graftSelectionMissingUnknown: 0,
    numberOfStrands2: 0,
    numberOfStrands3: 0,
    numberOfStrands4: 0,
    numberOfStrands5: 0,
    numberOfStrands6: 0,
    numberOfStrands7: 0,
    numberOfStrands8: 0,
    numberOfStrandsMissingUnknown: 0,
    graftDiameter6mm: 0,
    graftDiameter65mm: 0,
    graftDiameter7mm: 0,
    graftDiameter75mm: 0,
    graftDiameter8mm: 0,
    graftDiameter85mm: 0,
    graftDiameter9mm: 0,
    graftDiameter95mm: 0,
    graftDiameter10mm: 0,
    graftDiameter105mm: 0,
    graftDiameter11mm: 0,
    graftDiameter115mm: 0,
    graftDiameter12mm: 0,
    graftDiameter125mm: 0,
    graftDiameterMissingUnknown: 0,
    lateralExtraarticularProcedureTypeAll: 0,
    lateralExtraarticularProcedureTypeLet: 0,
    lateralExtraarticularProcedureTypeOther: 0,
    syntheticAugmentation: 0,
    aclRepair: 0,
    aclRepairFemoralFixationCombination: 0,
    aclRepairFemoralFixationCrosspin: 0,
    aclRepairFemoralFixationInterference: 0,
    aclRepairFemoralFixationSuspensory: 0,
    aclRepairFemoralFixationUnknownNotRecorded: 0,
    aclRepairFemoralFixationMaterialBioabsorbable: 0,
    aclRepairFemoralFixationMaterialMetal: 0,
    aclRepairFemoralFixationMaterialPeek: 0,
    aclRepairFemoralFixationMaterialUnknownNotRecd: 0,
    aclRepairTibialFixationCombination: 0,
    aclRepairTibialFixationInterference: 0,
    aclRepairTibialFixationSuspensory: 0,
    aclRepairTibialFixationMissingUnknown: 0,
    aclRepairTibialFixationMaterialBioabsorbable: 0,
    aclRepairTibialFixationMaterialMetal: 0,
    aclRepairTibialFixationMaterialPeek: 0,
    aclRepairTibialFixationMaterialMissingUnknown: 0,
    aclRepairFemoralTunnelDrillTechnAnteromedialPortal: 0,
    aclRepairFemoralTunnelDrillTechnOutsideInApproach: 0,
    aclRepairFemoralTunnelDrillTechnTransTibial: 0,
    aclRepairFemoralTunnelDrillTechnMissingUnknown: 0,
  });

  const [type5Details, setType5Details] = useState({
    totalNo: 0,
    followUpTimeInYearsMedianIqr: 0,
    cumulativeRevisionAt2Years: 0,
    cumulativeRevisionAt5Years: 0,
    cumulativeRevisionAt10Years: 0,
    cumulativeIpsilateralReoperationAt2Years: 0,
    cumulativeIpsilateralReoperationAt5Years: 0,
    cumulativeIpsilateralReoperationAt10Years: 0,
    contralateralKneeOperationsAt2Years: 0,
    contralateralKneeOperationsAt5Years: 0,
    contralateralKneeOperationsAt10Years: 0,
    deathAt2Years: 0,
    deathAt5Years: 0,
    deathAt10Years: 0,
    lostToFollowUpAt2Years: 0,
    lostToFollowUpAt5Years: 0,
    lostToFollowUpAt10Years: 0
  });

  const [type6Details, setType6Details] = useState({
    sane: 0,
    saneAt1yrPostoptTotn: 0,
    saneAt2yrPostoptTotn: 0,
    saneAt5yrPostoptTotn: 0,
    saneAt10yrPostoptTotn: 0,
    koosSubscaleMeanSd: 0,
    koosSubscalePreoperativeTotalN: 0,
    koosSubscalePreoperativePain: 0,
    koosSubscalePreoperativeSymptoms: 0,
    koosSubscalePreoperativeActiviDailLiv: 0,
    koosSubscalePreoperativeSportsRecreation: 0,
    koosSubscalePreoperativeQualityOfLife: 0,
    koosSubscaleAt1YearPostoperativeTotalN: 0,
    koosSubscaleAt1YearPostoperativePain: 0,
    koosSubscaleAt1YearPostoperativeSymptoms: 0,
    koosSubscaleAt1YearPostoperativeActiviDailLiv: 0,
    koosSubscaleAt1YearPostoperativeSportsRecreation: 0,
    koosSubscaleAt1YearPostoperativeQualityOfLife: 0,
    koosSubscaleAt2YearPostoperativeTotalN: 0,
    koosSubscaleAt2YearPostoperativePain: 0,
    koosSubscaleAt2YearPostoperativeSymptoms: 0,
    koosSubscaleAt2YearPostoperativeActiviDailLiv: 0,
    koosSubscaleAt2YearPostoperativeSportsRecreation: 0,
    koosSubscaleAt2YearPostoperativeQualityOfLife: 0,
    koosSubscaleAt5YearPostoperativeTotalN: 0,
    koosSubscaleAt5YearPostoperativePain: 0,
    koosSubscaleAt5YearPostoperativeSymptoms: 0,
    koosSubscaleAt5YearPostoperativeActiviDailLiv: 0,
    koosSubscaleAt5YearPostoperativeSportsRecreation: 0,
    koosSubscaleAt5YearPostoperativeQualityOfLife: 0,
    koosSubscaleAt10YearPostoperativeTotalN: 0,
    koosSubscaleAt10YearPostoperativePain: 0,
    koosSubscaleAt10YearPostoperativeSymptoms: 0,
    koosSubscaleAt10YearPostoperativeActiviDailLiv: 0,
    koosSubscaleAt10YearPostoperativeSportsRecreation: 0,
    koosSubscaleAt10YearPostoperativeQualityOfLife: 0,
    eq5dIndexMeanSd: 0,
    eq5dPreoperativeTotalN: 0,
    eq5dPreoperativeMobility: 0,
    eq5dPreoperativeSelfCare: 0,
    eq5dPreoperativeUsualActivities: 0,
    eq5dPreoperativePainDiscomfort: 0,
    eq5dPreoperativeAnxietyDepression: 0,
    eq5dAt1YearPostoperativeTotalN: 0,
    eq5dAt1YearPostoperativeMobility: 0,
    eq5dAt1YearPostoperativeSelfCare: 0,
    eq5dAt1YearPostoperativeUsualActivities: 0,
    eq5dAt1YearPostoperativePainDiscomfort: 0,
    eq5dAt1YearPostoperativeAnxietyDepression: 0,
    eq5dAt2YearsPostoperativeTotalN: 0,
    eq5dAt2YearsPostoperativeMobility: 0,
    eq5dAt2YearsPostoperativeSelfCare: 0,
    eq5dAt2YearsPostoperativeUsualActivities: 0,
    eq5dAt2YearsPostoperativePainDiscomfort: 0,
    eq5dAt2YearsPostoperativeAnxietyDepression: 0,
    eq5dAt5YearsPostoperativeTotalN: 0,
    eq5dAt5YearsPostoperativeMobility: 0,
    eq5dAt5YearsPostoperativeSelfCare: 0,
    eq5dAt5YearsPostoperativeUsualActivities: 0,
    eq5dAt5YearsPostoperativePainDiscomfort: 0,
    eq5dAt5YearsPostoperativeAnxietyDepression: 0,
    eq5dAt10YearsPostoperativeTotalN: 0,
    eq5dAt10YearsPostoperativeMobility: 0,
    eq5dAt10YearsPostoperativeSelfCare: 0,
    eq5dAt10YearsPostoperativeUsualActivities: 0,
    eq5dAt10YearsPostoperativePainDiscomfort: 0,
    eq5dAt10YearsPostoperativeAnxietyDepression: 0
  });

  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertError, setAlertError] = useState(false);

 // <----- fetching details for country list ----->
  const fetchCountry = async() =>{
      const orgId = userDetails?.orgId ?? userDetails?.OrgId ?? null;
      const isAdmin = userDetails?.admin === true;
      const url = !isAdmin && orgId != null
        ? `/Country?orgId=${orgId}`
        : '/Country';

      const result = await httpService.getData(url);
      if(result.isSuccess){ 
          setCountries(result.retObject);
      }     
  } 

  useEffect(() => {
      fetchCountry();    
  }, []);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const handleInputChange = (e, type) => {
    const { name, checked } = e.target;
    const value = checked ? 1 : 0;
    if (type === 1) {
      setSettingDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    if (type === 2) {
      setType2Details((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    if (type === 3) {
      setType3Details((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    if (type === 4) {
      setType4Details((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    if (type === 5) {
      setType5Details((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    if (type === 6) {
      setType6Details((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const applySelectAll = (prev, value) => {
    const updated = { ...prev };
    Object.keys(prev).forEach((key) => {
      if (!isSetupMetadataKey(key)) {
        updated[key] = value;
      }
    });
    return updated;
  };

  const handleSelectAllChange = (e, type) => {
    const checked = e.target.checked;
    const value = checked ? 1 : 0;
    if (type === 1) {
      setSettingDetails((prev) => applySelectAll(prev, value));
    }
    if (type === 2) {
      setType2Details((prev) => applySelectAll(prev, value));
    }
    if (type === 3) {
      setType3Details((prev) => applySelectAll(prev, value));
    }
    if (type === 4) {
      setType4Details((prev) => applySelectAll(prev, value));
    }
    if (type === 5) {
      setType5Details((prev) => applySelectAll(prev, value));
    }
    if (type === 6) {
      setType6Details((prev) => applySelectAll(prev, value));
    }
  };

  const isAllSelected = (obj) => {
    if (obj == null || typeof obj !== 'object') return false;
    const values = Object.entries(obj)
      .filter(([key]) => !isSetupMetadataKey(key))
      .map(([, val]) => val);
    return values.length > 0 && values.every((val) => val === 1);
  };

// <----- fetching details for edit page ----->   
    useEffect(() => {
        if (isEditing) {
            const fetchData = async () => {
                setIsPageLoading(true);
                try{
                    const result = await httpService.getData(`/Country/Details?countryId=${countryId}`);
                    const data = result?.retObject ?? {};
                    setSelectedCountry(data.countryCode ?? "");
                    // When a country has only some setups saved, API returns null for others; use current state defaults so we never set null
                    setSettingDetails(data.tblpatientcharacteristicssetup ?? settingDetails);
                    setType2Details(data.tblinjurymechanismsetup ?? type2Details);
                    setType3Details(data.tblconcurrentinjuriessetup ?? type3Details);
                    setType4Details(data.tblgraftselectionsetup ?? type4Details);
                    setType5Details(data.tbloutcomesaclrsetup ?? type5Details);
                    setType6Details(data.tblpatientreportedoutcomesetup ?? type6Details);
                }catch(err){
                    setAlertMessage("Error in fetching data!");
                    setAlertError(true);
                    setIsAlertModalOpen(true);
                }finally {
                    setIsPageLoading(false);
                }
            }
            fetchData();
        }else {
            setIsPageLoading(false);
        }
    }, [isEditing, countryId]);

  const handleFormSubmissionType1 = async (e) => {
    e.preventDefault();
    if (!selectedCountry) {
      setAlertMessage("Country selection is required !");
      setAlertError(true);
      setIsAlertModalOpen(true);
      return;
    }
    try{
      setLoading(true);
      const addedBy = userDetails?.loginid ?? userDetails?.Loginid ?? getStoredUser()?.loginid ?? getStoredUser()?.Loginid ?? '';
      const setupId = resolveSetupId(settingDetails, 'patientcharacteristicssetupid', 'Patientcharacteristicssetupid');
      const payload = sanitizeSetupPayload(settingDetails, {
        countryCode: selectedCountry,
        addedBy,
        isUpdate: setupId != null,
      });
      if (setupId != null) {
        payload.patientcharacteristicssetupid = setupId;
      }
      console.log("Payload : ", payload);
      if (setupId != null) {
        const result = await httpService.putData(`/PatientCharacteristicsSetup/${setupId}`, payload);
        if(result.isSuccess){
          setAlertMessage("Patient characteristics updated successfully!");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }else{
        const result = await httpService.postData('/PatientCharacteristicsSetup', payload);
        if(result.isSuccess){
          setAlertMessage("Patient characteristics added successfully !");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }
    }catch(error){
      console.error('Failed:', error);
      setAlertMessage("Error occured during detail submission !");
      setAlertError(true);
      setIsAlertModalOpen(true);
    }finally{
      setLoading(false);
    }
  }

  const handleFormSubmissionType2 = async (e) => {
    e.preventDefault();
    if (!selectedCountry) {
      setAlertMessage("Country selection is required !");
      setAlertError(true);
      setIsAlertModalOpen(true);
      return;
    }
    try{
      setLoading2(true);
      const addedBy = userDetails?.loginid ?? userDetails?.Loginid ?? getStoredUser()?.loginid ?? getStoredUser()?.Loginid ?? '';
      const setupId = resolveSetupId(type2Details, 'injurymechanismsetupid', 'Injurymechanismsetupid');
      const payload = sanitizeSetupPayload(type2Details, {
        countryCode: selectedCountry,
        addedBy,
        isUpdate: setupId != null,
      });
      if (setupId != null) {
        payload.injurymechanismsetupid = setupId;
      }
      console.log("Payload : ", payload);
      //return;
      if (setupId != null) {
        const result = await httpService.putData(`/InjuryMechanism/${setupId}`, payload);
        if(result.isSuccess){
          setAlertMessage("Mechanism of injury updated successfully!");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }else{
        const result = await httpService.postData('/InjuryMechanism', payload);
        if(result.isSuccess){
          setAlertMessage("Mechanism of injury added successfully !");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }
    }catch(error){
      console.error('Failed:', error);
      setAlertMessage("Error occured during detail submission !");
      setAlertError(true);
      setIsAlertModalOpen(true);
    }finally{
      setLoading2(false);
    }
  }

  const handleFormSubmissionType3 = async (e) => {
    e.preventDefault();
    if (!selectedCountry) {
      setAlertMessage("Country selection is required !");
      setAlertError(true);
      setIsAlertModalOpen(true);
      return;
    }
    try{
      setLoading3(true);
      const addedBy = userDetails?.loginid ?? userDetails?.Loginid ?? getStoredUser()?.loginid ?? getStoredUser()?.Loginid ?? '';
      const setupId = resolveSetupId(type3Details, 'concurrentinjuriessetupid', 'Concurrentinjuriessetupid');
      const payload = sanitizeSetupPayload(type3Details, {
        countryCode: selectedCountry,
        addedBy,
        isUpdate: setupId != null,
      });
      if (setupId != null) {
        payload.concurrentinjuriessetupid = setupId;
      }
      console.log("Payload : ", payload);
      //return;
      if (setupId != null) {
        const result = await httpService.putData(`/ConcurrentInjuries/${setupId}`, payload);
        if(result.isSuccess){
          setAlertMessage("Concurrent injuries details updated successfully!");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }else{
        const result = await httpService.postData('/ConcurrentInjuries', payload);
        if(result.isSuccess){
          setAlertMessage("Concurrent injuries added successfully !");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }
    }catch(error){
      console.error('Failed:', error);
      setAlertMessage("Error occured during detail submission !");
      setAlertError(true);
      setIsAlertModalOpen(true);
    }finally{
      setLoading3(false);
    }
  }

  const handleFormSubmissionType4 = async (e) => {
    e.preventDefault();
    if (!selectedCountry) {
      setAlertMessage("Country selection is required !");
      setAlertError(true);
      setIsAlertModalOpen(true);
      return;
    }
    try{
      setLoading4(true);
      const addedBy = userDetails?.loginid ?? userDetails?.Loginid ?? getStoredUser()?.loginid ?? getStoredUser()?.Loginid ?? '';
      const setupId = resolveSetupId(type4Details, 'graftselectionsetupid', 'Graftselectionsetupid', 'tblGraftselectionsetupid');
      const payload = sanitizeSetupPayload(type4Details, {
        countryCode: selectedCountry,
        addedBy,
        isUpdate: setupId != null,
      });
      if (setupId != null) {
        payload.graftselectionsetupid = setupId;
      }
      console.log("Payload : ", payload);
      //return;
      if (setupId != null) {
        const result = await httpService.putData(`/GraftSelection/${setupId}`, payload);
        if(result.isSuccess){
          setAlertMessage("Graft selection details updated successfully!");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }else{
        const result = await httpService.postData('/GraftSelection', payload);
        if(result.isSuccess){
          setAlertMessage("Graft selection added successfully !");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }
    }catch(error){
      console.error('Failed:', error);
      setAlertMessage("Error occured during detail submission !");
      setAlertError(true);
      setIsAlertModalOpen(true);
    }finally{
      setLoading4(false);
    }
  }

  const handleFormSubmissionType5 = async (e) => {
    e.preventDefault();
    if (!selectedCountry) {
      setAlertMessage("Country selection is required !");
      setAlertError(true);
      setIsAlertModalOpen(true);
      return;
    }
    try{
      setLoading5(true);
      const addedBy = userDetails?.loginid ?? userDetails?.Loginid ?? getStoredUser()?.loginid ?? getStoredUser()?.Loginid ?? '';
      const setupId = resolveSetupId(type5Details, 'outcomesaclrsetupid', 'Outcomesaclrsetupid');
      const payload = sanitizeSetupPayload(type5Details, {
        countryCode: selectedCountry,
        addedBy,
        isUpdate: setupId != null,
      });
      if (setupId != null) {
        payload.outcomesaclrsetupid = setupId;
      }
      console.log("Payload : ", payload);
      //return;
      if (setupId != null) {
        const result = await httpService.putData(`/Outcomes/${setupId}`, payload);
        if(result.isSuccess){
          setAlertMessage("Outcome details updated successfully!");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }else{
        const result = await httpService.postData('/Outcomes', payload);
        if(result.isSuccess){
          setAlertMessage("Outcome added successfully !");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }
    }catch(error){
      console.error('Failed:', error);
      setAlertMessage("Error occured during detail submission !");
      setAlertError(true);
      setIsAlertModalOpen(true);
    }finally{
      setLoading5(false);
    }
  }

  const handleFormSubmissionType6 = async (e) => {
    e.preventDefault();
    if (!selectedCountry) {
      setAlertMessage("Country selection is required !");
      setAlertError(true);
      setIsAlertModalOpen(true);
      return;
    }
    try{  
      setLoading6(true);
      const addedBy = userDetails?.loginid ?? userDetails?.Loginid ?? getStoredUser()?.loginid ?? getStoredUser()?.Loginid ?? '';
      const setupId = resolveSetupId(type6Details, 'patientreportedoutcomesetupid', 'Patientreportedoutcomesetupid');
      const payload = sanitizeSetupPayload(type6Details, {
        countryCode: selectedCountry,
        addedBy,
        isUpdate: setupId != null,
      });
      if (setupId != null) {
        payload.patientreportedoutcomesetupid = setupId;
      }
      console.log("Payload : ", payload);
      //return;
      if (setupId != null) {
        const result = await httpService.putData(`/PatientReportedOutcomeMeasure/${setupId}`, payload);
        if(result.isSuccess){
          setAlertMessage("Patient reported outcome measures updated successfully!");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }else{
        const result = await httpService.postData('/PatientReportedOutcomeMeasure', payload);
        if(result.isSuccess){
          setAlertMessage("Patient reported outcome measures added successfully !");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }
    }catch(error){
      console.error('Failed:', error);
      setAlertMessage("Error occured during detail submission !");
      setAlertError(true);
      setIsAlertModalOpen(true);
    }finally{
      setLoading6(false);
    }
  }

  const handleSave = (type) => {

    if (!selectedCountry) {
      alert("Please select country first");
      return;
    }

    if (type === 1) {
      const payload = {
        countryCode: selectedCountry,
        type: 1,
        ...settingDetails,
      };
      console.log("Saving Type 1", payload);
    }

    if (type === 2) {
      const payload = {
        countryCode: selectedCountry,
        type: 2,
        ...type2Details,
      };
      console.log("Saving Type 2", payload);
    }
  };

  return (
    <div className="app-content p-4">
      <div className="container-fluid mt-2">
        <div className="text-start mb-4">
          <Link to="/mandatory-info" className="back-icon">
              <i className="fa-solid fa-xl fa-circle-arrow-left"></i>
          </Link>
        </div>
        <div className="card custom-card">
          <div className="card-header">
            <div className="card-title">Settings</div>
          </div>
          <div className="card-body">
            {isPageLoading ? (
              <div className="d-flex justify-content-center align-items-center loader-container">
                  <button className="btn btn-outline-secondary mt-3" type="button">
                      <span className="spinner-border spinner-border-sm align-middle me-2" role="status"
                        aria-hidden="true"></span>
                      Loading...
                  </button>
              </div>                                       
            ) : (
              <form>
                <div className="row mt-3 mb-4">
                  <label className="col-form-label col-sm-2">Country :</label>
                  <div className="col-sm-4">
                    <select className="form-select" value={selectedCountry} onChange={handleCountryChange} disabled={isEditing}>
                      <option value="">Select</option>
                      {countries.map((item, index) => (
                        <option key={index} value={item.countryCode}>
                          {item.countryName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <h4 className="section-heading">
                  Select the fields to mark as mandatory
                </h4>
                <div className="accordion" id="settingsAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#type1" >
                        Patient characteristics and procedure
                      </button>
                    </h2>
                    <div id="type1" className="accordion-collapse collapse show" >
                      <div className="accordion-body">
                        <div className="mb-3">
                          <input type="checkbox" className="form-check-input" checked={isAllSelected(settingDetails)}
                            onChange={(e) => handleSelectAllChange(e, 1)}
                          />
                          <label className="ms-2">Select All</label>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                              <div className="mb-3 row">
                                <label htmlFor="" className="col-form-label">Gender :</label>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="genderMale" checked={settingDetails.genderMale === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Male</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="genderFemale" checked={settingDetails.genderFemale === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Female</label>
                                </div>
                                <div className="col-sm-5">
                                  <input className="form-check-input" type="checkbox" name="genderMissingUnknown" checked={settingDetails.genderMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Missing/unknown</label>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <label htmlFor="" className="col-form-label">Age at time of surgery, in years, n (%) :</label>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="ageAtAclrYearsLt15" checked={settingDetails.ageAtAclrYearsLt15 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">&lt;15</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="ageAtAclrYears1519" checked={settingDetails.ageAtAclrYears1519 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">15-19</label>
                                </div>
                                <div className="col-sm-4">
                                  <input className="form-check-input" type="checkbox" name="ageAtAclrYears2024" checked={settingDetails.ageAtAclrYears2024 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">20-24</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="ageAtAclrYears2529" checked={settingDetails.ageAtAclrYears2529 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">25-29</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="ageAtAclrYears3034" checked={settingDetails.ageAtAclrYears3034 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">30-34</label>
                                </div>
                                <div className="col-sm-4">
                                  <input className="form-check-input" type="checkbox" name="ageAtAclrYears3539" checked={settingDetails.ageAtAclrYears3539 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">35-39</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="ageAtAclrYearsGte40" checked={settingDetails.ageAtAclrYearsGte40 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">&gt;40</label>
                                </div>
                                <div className="col-sm-5">
                                  <input className="form-check-input" type="checkbox" name="ageAtAclrYearsMissingUnknown" checked={settingDetails.ageAtAclrYearsMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Missing/unknown</label>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <label htmlFor="" className="col-form-label">Body mass index, kg/m2, n (%) :</label>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="bmiLt25" checked={settingDetails.bmiLt25 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">&lt;25</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="bmi2529" checked={settingDetails.bmi2529 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">25-29</label>
                                </div>
                                <div className="col-sm-4">
                                  <input className="form-check-input" type="checkbox" name="bmiGte30" checked={settingDetails.bmiGte30 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">&ge;30</label>
                                </div>
                                <div className="col-sm-5">
                                  <input className="form-check-input" type="checkbox" name="bmiMissingUnknown" checked={settingDetails.bmiMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Missing/unknown</label>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <label htmlFor="" className="col-form-label">Operative side, n (%) :</label>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="operativeSideLeft" checked={settingDetails.operativeSideLeft === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Left</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="operativeSideRight" checked={settingDetails.operativeSideRight === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Right</label>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <label htmlFor="" className="col-form-label">Prior operation in index knee, n (%) :</label>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="priorOperationNo" checked={settingDetails.priorOperationNo === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">No</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="priorOperationYes" checked={settingDetails.priorOperationYes === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Yes</label>
                                </div>
                                <div className="col-sm-5">
                                  <input className="form-check-input" type="checkbox" name="priorOperationMissingUnknown" checked={settingDetails.priorOperationMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Missing/unknown</label>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <label htmlFor="" className="col-form-label">Contralateral knee normal, n (%) :</label>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="contralateralKneeNormalNo" checked={settingDetails.contralateralKneeNormalNo === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">No</label>
                                </div>
                                <div className="col-sm-3">
                                  <input className="form-check-input" type="checkbox" name="contralateralKneeNormalYes" checked={settingDetails.contralateralKneeNormalYes === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Yes</label>
                                </div>
                                <div className="col-sm-5">
                                  <input className="form-check-input" type="checkbox" name="contralateralKneeNormalMissingUnknown" checked={settingDetails.contralateralKneeNormalMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor="">Missing/unknown</label>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <label htmlFor="" className="col-form-label">Operative time, minutes, mean (SD) :</label>
                                <div className="col-sm-5">
                                  <input className="form-check-input" type="checkbox" name="operativeTimeMissingUnknown" checked={settingDetails.operativeTimeMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                  <label className="ms-2" htmlFor=""> Missing/unknown</label>
                                </div>
                              </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row mb-3">
                              <label htmlFor="" className="col-form-label">ASA Classification :</label>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="asa12" checked={settingDetails.asa12 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">1-2</label>
                              </div>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="asaGte3" checked={settingDetails.asaGte3 === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">&ge;3</label>
                              </div>
                              <div className="col-sm-5">
                                <input className="form-check-input" type="checkbox" name="asaMissingUnknown" checked={settingDetails.asaMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Missing/unknown</label>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label htmlFor="" className="col-sm-10 col-form-label">Race :</label>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="raceAsian" checked={settingDetails.raceAsian === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Asian</label>
                                </div>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="raceBlack" checked={settingDetails.raceBlack === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Black</label>
                              </div>
                              <div className="col-sm-4">
                                <input className="form-check-input" type="checkbox" name="raceHispanic" checked={settingDetails.raceHispanic === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Hispanic</label>
                              </div>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="raceWhite" checked={settingDetails.raceWhite === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">White</label>
                              </div>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="raceOther" checked={settingDetails.raceOther === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Other</label>
                              </div>
                              <div className="col-sm-5">
                                <input className="form-check-input" type="checkbox" name="raceMissingUnknown" checked={settingDetails.raceMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Missing/unknown</label>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label htmlFor="" className="col-form-label">Smoking, n (%) :</label>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="smokingNo" checked={settingDetails.smokingNo === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">No</label>
                              </div>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="smokingYes" checked={settingDetails.smokingYes === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Yes</label>
                              </div>
                              <div className="col-sm-5">
                                <input className="form-check-input" type="checkbox" name="smokingMissingUnknown" checked={settingDetails.smokingMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Missing/unknown</label>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label htmlFor="" className="col-form-label">Time to reconstructionc, in months, n (%) :</label>
                              <div className="col-sm-4">
                                <input className="form-check-input" type="checkbox" name="timeToAclr03wks" checked={settingDetails.timeToAclr03wks === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">0 to &lt;3 weeks</label>
                              </div>
                              <div className="col-sm-6">
                                <input className="form-check-input" type="checkbox" name="timeToAclr3wks3mo" checked={settingDetails.timeToAclr3wks3mo === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">3 weeks to &lt;3 months</label>
                              </div>
                              <div className="col-sm-6">
                                <input className="form-check-input" type="checkbox" name="timeToAclr3mo9mo" checked={settingDetails.timeToAclr3mo9mo === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">3 months to &lt;9 months</label>
                              </div>
                              <div className="col-sm-5">
                                <input className="form-check-input" type="checkbox" name="timeToAclrGte9mo" checked={settingDetails.timeToAclrGte9mo === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">&ge;9 months</label>
                              </div>
                              <div className="col-sm-5">
                                <input className="form-check-input" type="checkbox" name="timeToAclrMissingUnknown" checked={settingDetails.timeToAclrMissingUnknown === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Missing/unknown</label>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label htmlFor="" className="col-form-label">Infection prophylaxis, n (%) :</label>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="infectionProphylaxisNo" checked={settingDetails.infectionProphylaxisNo === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">No</label>
                              </div>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="infectionProphylaxisYes" checked={settingDetails.infectionProphylaxisYes === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Yes</label>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label htmlFor="" className="col-form-label">Thrombosis prophylaxis, n (%) :</label>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="thrombosisProphylaxisNo" checked={settingDetails.thrombosisProphylaxisNo === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">No</label>
                              </div>
                              <div className="col-sm-3">
                                <input className="form-check-input" type="checkbox" name="thrombosisProphylaxisYes" checked={settingDetails.thrombosisProphylaxisYes === 1} onChange={(e) => handleInputChange(e, 1)}/>
                                <label className="ms-2" htmlFor="">Yes</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-2 mt-4 mb-2">
                              {loading ? (
                                  <div className='save-btn-with-loader'>
                                      <button className="btn blue-btn mt-3 me-2">Save</button>
                                      <div className="spinner-border text-primary mt-3" role="status">
                                          <span className="visually-hidden">Loading...</span>
                                      </div>
                                  </div>
                              ):(
                                  <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmissionType1}>Save</button>
                              )}
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-md-2 mt-4 mb-2">
                            <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmissionType1()}>Save</button>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#type2" >
                        Mechanism of injury / etiology 
                      </button>
                    </h2>
                    <div id="type2" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        <div className="mb-3">
                          <input className="form-check-input" type="checkbox" checked={isAllSelected(type2Details)} onChange={(e) => handleSelectAllChange(e, 2)}/>
                          <label className="ms-2">Select All</label>
                        </div>
                        <div className="row">
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="skiingSnowboarding"
                              checked={type2Details.skiingSnowboarding === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Skiing/snowboarding</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="altercation"
                              checked={type2Details.altercation === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Altercation</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="americanFootball"
                              checked={type2Details.americanFootball === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">American Football</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="rugby"
                              checked={type2Details.rugby === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Rugby</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="baseball"
                              checked={type2Details.baseball === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Baseball</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="basketball"
                              checked={type2Details.basketball === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Basketball</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="netball"
                              checked={type2Details.netball === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Netball</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="cycling"
                              checked={type2Details.cycling === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Cycling</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="danceGymnasticsCheer"
                              checked={type2Details.danceGymnasticsCheer === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Dance/Gymnastics/Cheer</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="exercisingGym"
                              checked={type2Details.exercisingGym === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Exercising/Gym</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox"  name="fall"
                              checked={type2Details.fall === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Fall</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="fieldHockeyLacrosse"
                              checked={type2Details.fieldHockeyLacrosse === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Field Hockey/Lacrosse</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="floorBall"
                              checked={type2Details.floorBall === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Floor Ball</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="frisbee"
                              checked={type2Details.frisbee === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Frisbee</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input" type="checkbox" name="handball"
                              checked={type2Details.handball === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Handball</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input className="form-check-input"
                              type="checkbox" name="horseRidingBullRiding"
                              checked={type2Details.horseRidingBullRiding === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Horse riding/Bull riding</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="iceHockeyBandy"
                              checked={type2Details.iceHockeyBandy === 1}     
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Ice Hockey/Bandy</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="jumpingTrampoline"
                              checked={type2Details.jumpingTrampoline === 1}    
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Jumping/Trampoline</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="racquetSportsTennis"
                              checked={type2Details.racquetSportsTennis === 1}      
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Racquet sports/Tennis</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="rollerSkatingSkateboarding"
                              checked={type2Details.rollerSkatingSkateboarding === 1}     
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Roller skating/Skateboarding</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="soccerFootball"
                              checked={type2Details.soccerFootball === 1}     
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Soccer (Football?)</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="volleyball"
                              checked={type2Details.volleyball === 1}   
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Volleyball</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="waterSports"
                              checked={type2Details.waterSports === 1}     
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Water sports</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="workInjury"
                              checked={type2Details.workInjury === 1}      
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Work injury</label>
                          </div>
                          <div className="col-sm-6 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="motorsportsMotorVehicleAccidentTraffic"
                              checked={type2Details.motorsportsMotorVehicleAccidentTraffic === 1}     
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Motorsports/Motor Vehicle Accident/Traffic</label>
                          </div>
                          <div className="col-sm-6 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="martialArtsKampSportWrestling"
                              checked={type2Details.martialArtsKampSportWrestling === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Martial arts/Kamp sport/Wrestling</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="otherSport"
                              checked={type2Details.otherSport === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Other sport</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="otherSpareTime"
                              checked={type2Details.otherSpareTime === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Other spare time</label>
                          </div>
                          <div className="col-sm-6 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="hikingJoggingRunningWalking"
                              checked={type2Details.hikingJoggingRunningWalking === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Hiking/Jogging/Running/Walking</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="other"
                              checked={type2Details.other === 1}    
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Other</label>
                          </div>
                          <div className="col-sm-3 mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="missingUnknown"
                              checked={type2Details.missingUnknown === 1}
                              onChange={(e) => handleInputChange(e, 2)}
                            />
                            <label className="ms-2">Missing/unknown</label>
                          </div>

                        </div>
                        <div className="row">
                          <div className="col-md-2 mt-4 mb-2">
                            {loading2 ? (
                                <div className='save-btn-with-loader'>
                                    <button className="btn blue-btn mt-3 me-2">Save</button>
                                    <div className="spinner-border text-primary mt-3" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ):(
                                <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmissionType2}>Save</button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#type3" >
                        Concurrent injuries and intra-operative 
                      </button>
                    </h2>
                    <div id="type3" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        <div className="mb-3">
                          <input className="form-check-input" type="checkbox" checked={isAllSelected(type3Details)} onChange={(e) => handleSelectAllChange(e, 3)}/>
                          <label className="ms-2">Select All</label>
                        </div>
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">Ligament pathology :</h4>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Multi-ligament injury :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="multiLigamentInjuryNo" checked={type3Details.multiLigamentInjuryNo === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">No</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="multiLigamentInjuryYes" checked={type3Details.multiLigamentInjuryYes === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Yes</label>
                          </div>
                        </div>
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">Other ligament injury/treatment :</h4>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">MCL Treatment :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="mclTreatmentInjuryThatWasTreated"
                              checked={type3Details.mclTreatmentInjuryThatWasTreated === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">Injury that was treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="mclTreatmentInjuryThatWasNotTreated"
                              checked={type3Details.mclTreatmentInjuryThatWasNotTreated === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">Injury that was not treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="noInjuryTreatment"
                              checked={type3Details.noInjuryTreatment === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">No injury/treatment</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">LCL Treatment :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="lclTreatmentInjuryThatWasTreated"
                              checked={type3Details.lclTreatmentInjuryThatWasTreated === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">Injury that was treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="lclTreatmentInjuryThatWasNotTreated"
                              checked={type3Details.lclTreatmentInjuryThatWasNotTreated === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">Injury that was not treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="lclTreatmentNoInjuryTreatment"
                              checked={type3Details.lclTreatmentNoInjuryTreatment === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">No injury/treatment</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">PLC Treatment :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="plcTreatmentInjuryThatWasTreated"
                              checked={type3Details.plcTreatmentInjuryThatWasTreated === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">Injury that was treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="plcTreatmentInjuryThatWasNotTreated"
                              checked={type3Details.plcTreatmentInjuryThatWasNotTreated === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">Injury that was not treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="plcTreatmentNoInjuryTreatment"
                              checked={type3Details.plcTreatmentNoInjuryTreatment === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">No injury/treatment</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">PCL Treatment :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="pclTreatmentInjuryThatWasTreated"
                              checked={type3Details.pclTreatmentInjuryThatWasTreated === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">Injury that was treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="pclTreatmentInjuryThatWasNotTreated"
                              checked={type3Details.pclTreatmentInjuryThatWasNotTreated === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">Injury that was not treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="pclTreatmentNoInjuryTreatment"
                              checked={type3Details.pclTreatmentNoInjuryTreatment === 1}
                              onChange={(e) => handleInputChange(e, 3)}
                            />
                            <label className="ms-2">No injury/treatment</label>
                          </div>
                        </div>
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">Meniscal pathology : </h4>
                        </div>
                        <div className="row mb-3">
                          <div className="col-12 mb-2">
                            <input className="form-check-input" type="checkbox" id="lateralMeniscusInjuryTreatment" name="lateralMeniscusInjuryTreatment" checked={type3Details.lateralMeniscusInjuryTreatment === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2 col-form-label d-inline" htmlFor="lateralMeniscusInjuryTreatment">Lateral meniscus injury/treatment</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryInjuryThatWasTreated" checked={type3Details.lateralMeniscusInjuryInjuryThatWasTreated === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Injury that was treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryInjuryThatWasNotTreated" checked={type3Details.lateralMeniscusInjuryInjuryThatWasNotTreated === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Injury that was not treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryNoInjuryTreatment" checked={type3Details.lateralMeniscusInjuryNoInjuryTreatment === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">No injury/treatment</label>
                          </div>
                        </div>
                        {type3Details.lateralMeniscusInjuryInjuryThatWasTreated === 1 && (
                          <div className="row">
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryInjuryThatWasTreatedLeftSitu" checked={type3Details.lateralMeniscusInjuryInjuryThatWasTreatedLeftSitu === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Left in situ</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryInjuryThatWasTreatedRasped" checked={type3Details.lateralMeniscusInjuryInjuryThatWasTreatedRasped === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Rasped</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryInjuryThatWasTreatedRepair" checked={type3Details.lateralMeniscusInjuryInjuryThatWasTreatedRepair === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Repair</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryInjuryThatWasTreatedRepBio" checked={type3Details.lateralMeniscusInjuryInjuryThatWasTreatedRepBio === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Repair with biologics</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryInjuryThatWasTreatedParMenis" checked={type3Details.lateralMeniscusInjuryInjuryThatWasTreatedParMenis === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Partial menisectomy</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="lateralMeniscusInjuryInjuryThatWasTreatedTrephinat" checked={type3Details.lateralMeniscusInjuryInjuryThatWasTreatedTrephinat === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Trephinated</label>
                            </div>
                          </div>
                        )}
                        <div className="row mb-3">
                          <div className="col-12 mb-2">
                            <input className="form-check-input" type="checkbox" id="medialMeniscusInjuryTreatment" name="medialMeniscusInjuryTreatment" checked={type3Details.medialMeniscusInjuryTreatment === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2 col-form-label d-inline" htmlFor="medialMeniscusInjuryTreatment">Medial meniscus injury/treatment</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryInjuryThatWasTreated" checked={type3Details.medialMeniscusInjuryInjuryThatWasTreated === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Injury that was treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryInjuryThatWasNotTreated" checked={type3Details.medialMeniscusInjuryInjuryThatWasNotTreated === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Injury that was not treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryNoInjuryTreatment" checked={type3Details.medialMeniscusInjuryNoInjuryTreatment === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">No injury/treatment</label>
                          </div>
                        </div>
                        {type3Details.medialMeniscusInjuryInjuryThatWasTreated === 1 && (
                          <div className="row">
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryInjuryThatWasTreatedLeftSitu" checked={type3Details.medialMeniscusInjuryInjuryThatWasTreatedLeftSitu === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Left in situ</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryInjuryThatWasTreatedRasped" checked={type3Details.medialMeniscusInjuryInjuryThatWasTreatedRasped === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Rasped</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryInjuryThatWasTreatedRepair" checked={type3Details.medialMeniscusInjuryInjuryThatWasTreatedRepair === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Repair</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryInjuryThatWasTreatedRepBio" checked={type3Details.medialMeniscusInjuryInjuryThatWasTreatedRepBio === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Repair with biologics</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryInjuryThatWasTreatedParMenis" checked={type3Details.medialMeniscusInjuryInjuryThatWasTreatedParMenis === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Partial menisectomy</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="medialMeniscusInjuryInjuryThatWasTreatedTrephinat" checked={type3Details.medialMeniscusInjuryInjuryThatWasTreatedTrephinat === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Trephinated</label>
                            </div>
                          </div>
                        )}
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">Chondral pathology :</h4>
                        </div>
                        <div className="row mb-3">
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cartilageInjuryThatWasTreated" checked={type3Details.cartilageInjuryThatWasTreated === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Injury that was treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cartilageInjuryThatWasNotTreated" checked={type3Details.cartilageInjuryThatWasNotTreated === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Injury that was not treated</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cartilageNoInjuryTreatment" checked={type3Details.cartilageNoInjuryTreatment === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">No injury/treatment</label>
                          </div>
                        </div>
                        {type3Details.cartilageInjuryThatWasTreated === 1 && (
                          <div className="mb-3 row">
                            <label htmlFor="" className="col-form-label">Cartilage injury :</label>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryFromTrauma" checked={type3Details.cartilageInjuryFromTrauma === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Injury from trauma</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryOsteoarthritis" checked={type3Details.cartilageInjuryOsteoarthritis === 1}  onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Osteoarthritis</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryOther"  checked={type3Details.cartilageInjuryOther === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Other</label>
                            </div>
                          </div>
                        )}
                        {type3Details.cartilageInjuryThatWasTreated === 1 && (
                          <div className="mb-3 row">
                            <label htmlFor="" className="col-form-label">Cartilage injury location :</label>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryLocationPatella" checked={type3Details.cartilageInjuryLocationPatella === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Patella</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryLocationLfc" checked={type3Details.cartilageInjuryLocationLfc === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">LFC</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryLocationLtp" checked={type3Details.cartilageInjuryLocationLtp === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">LTP</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryLocationMfc" checked={type3Details.cartilageInjuryLocationMfc === 1}  onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">MFC</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryLocationMtp" checked={type3Details.cartilageInjuryLocationMtp === 1}  onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">MTP</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="cartilageInjuryLocationTrochlea" checked={type3Details.cartilageInjuryLocationTrochlea === 1} onChange={(e) => handleInputChange(e, 3)}/>
                              <label className="ms-2" htmlFor="">Trochlea</label>
                            </div>
                          </div>
                        )}
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">Type of treatment :</h4>
                        </div>
                        <div className="mb-3 row">
                          {/* <label htmlFor="" className="col-form-label section-sub-heading"></label> */}
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="typeOfTreatmentDebridment" checked={type3Details.typeOfTreatmentDebridment === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Debridment</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="typeOfTreatmentMicrofracture" checked={type3Details.typeOfTreatmentMicrofracture === 1}  onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Microfracture	</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="typeOfTreatmentTransplant" checked={type3Details.typeOfTreatmentTransplant === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Transplant</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="typeOfTreatmentMosaicplasty" checked={type3Details.typeOfTreatmentMosaicplasty === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Mosaicplasty</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="typeOfTreatmentAllograft" checked={type3Details.typeOfTreatmentAllograft === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Allograft	</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="typeOfTreatmentBiologicImplant" checked={type3Details.typeOfTreatmentBiologicImplant === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Biologic implant</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="typeOfTreatmentBiologicImplantName" checked={type3Details.typeOfTreatmentBiologicImplantName === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Biologic implant name</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="typeOfTreatmentOtherTypeOfTreatment" checked={type3Details.typeOfTreatmentOtherTypeOfTreatment === 1} onChange={(e) => handleInputChange(e, 3)}/>
                            <label className="ms-2" htmlFor="">Other type of treatment	</label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-2 mt-4 mb-2">
                              {loading3 ? (
                                  <div className='save-btn-with-loader'>
                                      <button className="btn blue-btn mt-3 me-2">Save</button>
                                      <div className="spinner-border text-primary mt-3" role="status">
                                          <span className="visually-hidden">Loading...</span>
                                      </div>
                                  </div>
                              ):(
                                  <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmissionType3}>Save</button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#type4" >
                        Graft selection, fixation devices, and tunnel drilling
                      </button>
                    </h2>
                    <div id="type4" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        <div className="mb-3">
                          <input className="form-check-input" type="checkbox" checked={isAllSelected(type4Details)} onChange={(e) => handleSelectAllChange(e, 4)}/>
                          <label className="ms-2">Select All</label>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Graft selection :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionAllograft" checked={type4Details.graftSelectionAllograft === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Allograft</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionPatellaTendonAutograft" checked={type4Details.graftSelectionPatellaTendonAutograft === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Patella tendon autograft</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionHamstringsTendonAtgraft" checked={type4Details.graftSelectionHamstringsTendonAtgraft === 1}  onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Hamstrings tendon autograft</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionQuadricepsTendonAtgraft" checked={type4Details.graftSelectionQuadricepsTendonAtgraft === 1}  onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Quadriceps tendon autograft</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionHybridGraft" checked={type4Details.graftSelectionHybridGraft === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Hybrid grafta</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionSyntheticGraft" checked={type4Details.graftSelectionSyntheticGraft === 1}  onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Synthetic graft</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionOtherGraft" checked={type4Details.graftSelectionOtherGraft === 1}  onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Other graft</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionSyntheticAugmentation" checked={type4Details.graftSelectionSyntheticAugmentation === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Synthetic augmentation</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftSelectionMissingUnknown" checked={type4Details.graftSelectionMissingUnknown === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Missing/unknown</label>
                          </div>
                        </div>
                        { type4Details.graftSelectionHamstringsTendonAtgraft === 1 && (
                          <div className="mb-3 row">
                            <label htmlFor="" className="col-form-label">Hamstrings tendon autograft :</label>                      
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="graftSelectionHamstringsTendonAtgraftGracillis" checked={type4Details.graftSelectionHamstringsTendonAtgraftGracillis === 1} onChange={(e) => handleInputChange(e, 4)}/>
                              <label className="ms-2" htmlFor="">Gracillis</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="graftSelectionHamstringsTendonAtgraftSmiT" checked={type4Details.graftSelectionHamstringsTendonAtgraftSmiT === 1} onChange={(e) => handleInputChange(e, 4)}/>
                              <label className="ms-2" htmlFor="">Semi-T</label>
                            </div>
                            <div className="col-sm-3">
                              <input className="form-check-input" type="checkbox" name="graftSelectionHamstringsTendonAtgraftSmiTGracls" checked={type4Details.graftSelectionHamstringsTendonAtgraftSmiTGracls === 1} onChange={(e) => handleInputChange(e, 4)}/>
                              <label className="ms-2" htmlFor="">Semi-T & Gracilis</label>
                            </div>
                          </div>
                        )}
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Number of Strands :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="numberOfStrands2" checked={type4Details.numberOfStrands2 === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">2</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="numberOfStrands3" checked={type4Details.numberOfStrands3 === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">3</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="numberOfStrands4" checked={type4Details.numberOfStrands4 === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">4</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="numberOfStrands5" checked={type4Details.numberOfStrands5 === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">5</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="numberOfStrands6" checked={type4Details.numberOfStrands6 === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">6</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="numberOfStrands7" checked={type4Details.numberOfStrands7 === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">7</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="numberOfStrands8" checked={type4Details.numberOfStrands8 === 1}  onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">8</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="numberOfStrandsMissingUnknown" checked={type4Details.numberOfStrandsMissingUnknown === 1}  onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Missing/unknown</label>
                          </div> 
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Graft diameter :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter6mm" checked={type4Details.graftDiameter6mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">6mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter65mm" checked={type4Details.graftDiameter65mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">6.5mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter7mm" checked={type4Details.graftDiameter7mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">7mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter75mm" checked={type4Details.graftDiameter75mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">7.5mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter8mm" checked={type4Details.graftDiameter8mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">8mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter85mm" checked={type4Details.graftDiameter85mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">8.5mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter9mm" checked={type4Details.graftDiameter9mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">9mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter95mm" checked={type4Details.graftDiameter95mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">9.5mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter10mm" checked={type4Details.graftDiameter10mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">10mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter105mm" checked={type4Details.graftDiameter105mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">10.5mm</label>
                          </div> 
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter11mm" checked={type4Details.graftDiameter11mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">11mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter115mm" checked={type4Details.graftDiameter115mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">11.5mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter12mm" checked={type4Details.graftDiameter12mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">12mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameter125mm" checked={type4Details.graftDiameter125mm === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">12.5mm</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="graftDiameterMissingUnknown" checked={type4Details.graftDiameterMissingUnknown === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Missing/unknown</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Lateral extraarticular procedure type :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="lateralExtraarticularProcedureTypeAll" checked={type4Details.lateralExtraarticularProcedureTypeAll === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">ALL</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="lateralExtraarticularProcedureTypeLet" checked={type4Details.lateralExtraarticularProcedureTypeLet === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">LET</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="lateralExtraarticularProcedureTypeOther" checked={type4Details.lateralExtraarticularProcedureTypeOther === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Other</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="syntheticAugmentation" checked={type4Details.syntheticAugmentation === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Synthetic Augmentation</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepair" checked={type4Details.aclRepair === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">ACL Repair</label>
                          </div>
                        </div>
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">ACL Repair :</h4>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Femoral fixation :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationCombination" checked={type4Details.aclRepairFemoralFixationCombination === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Combinationb</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationCrosspin" checked={type4Details.aclRepairFemoralFixationCrosspin === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Crosspin</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationInterference" checked={type4Details.aclRepairFemoralFixationInterference === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Interference</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationSuspensory" checked={type4Details.aclRepairFemoralFixationSuspensory === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Suspensory</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationUnknownNotRecorded" checked={type4Details.aclRepairFemoralFixationUnknownNotRecorded === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Unknown/Not recorded</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Femoral fixation material :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationMaterialBioabsorbable" checked={type4Details.aclRepairFemoralFixationMaterialBioabsorbable === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Bioabsorbable</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationMaterialMetal" checked={type4Details.aclRepairFemoralFixationMaterialMetal === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Metal</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationMaterialPeek" checked={type4Details.aclRepairFemoralFixationMaterialPeek === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">PEEK</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralFixationMaterialUnknownNotRecd" checked={type4Details.aclRepairFemoralFixationMaterialUnknownNotRecd === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Unknown/Not recorded</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Tibial fixation :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairTibialFixationCombination" checked={type4Details.aclRepairTibialFixationCombination === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Combinationb</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairTibialFixationInterference" checked={type4Details.aclRepairTibialFixationInterference === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Interference</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairTibialFixationSuspensory" checked={type4Details.aclRepairTibialFixationSuspensory === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Suspensory</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairTibialFixationMissingUnknown" checked={type4Details.aclRepairTibialFixationMissingUnknown === 1}  onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Missing/unknown	</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Tibial fixation material :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairTibialFixationMaterialBioabsorbable" checked={type4Details.aclRepairTibialFixationMaterialBioabsorbable === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Bioabsorbable</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairTibialFixationMaterialMetal" checked={type4Details.aclRepairTibialFixationMaterialMetal === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Metal</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairTibialFixationMaterialPeek" checked={type4Details.aclRepairTibialFixationMaterialPeek === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">PEEK</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairTibialFixationMaterialMissingUnknown" checked={type4Details.aclRepairTibialFixationMaterialMissingUnknown === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Unknown/Not recorded</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Femoral tunnel drilling technique :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralTunnelDrillTechnAnteromedialPortal" checked={type4Details.aclRepairFemoralTunnelDrillTechnAnteromedialPortal === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Anteromedial portal</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralTunnelDrillTechnOutsideInApproach" checked={type4Details.aclRepairFemoralTunnelDrillTechnOutsideInApproach === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Outside in approach</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralTunnelDrillTechnTransTibial" checked={type4Details.aclRepairFemoralTunnelDrillTechnTransTibial === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Trans tibial</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="aclRepairFemoralTunnelDrillTechnMissingUnknown" checked={type4Details.aclRepairFemoralTunnelDrillTechnMissingUnknown === 1} onChange={(e) => handleInputChange(e, 4)}/>
                            <label className="ms-2" htmlFor="">Missing/unknown</label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-2 mt-4 mb-2">
                              {loading4 ? (
                                  <div className='save-btn-with-loader'>
                                      <button className="btn blue-btn mt-3 me-2">Save</button>
                                      <div className="spinner-border text-primary mt-3" role="status">
                                          <span className="visually-hidden">Loading...</span>
                                      </div>
                                  </div>
                              ):(
                                  <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmissionType4}>Save</button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#type5" >
                        Outcomes
                      </button>
                    </h2>
                    <div id="type5" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        <div className="mb-3">
                          <input className="form-check-input" type="checkbox" checked={isAllSelected(type5Details)} onChange={(e) => handleSelectAllChange(e, 5)}/>
                          <label className="ms-2">Select All</label>
                        </div>
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">Follow-up time<sup>a</sup>, in years, median (IQR)	</h4>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Cumulative revision<sup>b</sup>, n (%<sup>c</sup>) :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cumulativeRevisionAt2Years" checked={type5Details.cumulativeRevisionAt2Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 2-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cumulativeRevisionAt5Years" checked={type5Details.cumulativeRevisionAt5Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 5-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cumulativeRevisionAt10Years" checked={type5Details.cumulativeRevisionAt10Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 10-years</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Cumulative ipsilateral reoperation<sup>d</sup>, n (%<sup>c</sup>) :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cumulativeIpsilateralReoperationAt2Years" checked={type5Details.cumulativeIpsilateralReoperationAt2Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 2-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cumulativeIpsilateralReoperationAt5Years" checked={type5Details.cumulativeIpsilateralReoperationAt5Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 5-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="cumulativeIpsilateralReoperationAt10Years" checked={type5Details.cumulativeIpsilateralReoperationAt10Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 10-years</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Contralateral knee operations<sup>e</sup>, n (%<sup>c</sup>) :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="contralateralKneeOperationsAt2Years" checked={type5Details.contralateralKneeOperationsAt2Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 2-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="contralateralKneeOperationsAt5Years" checked={type5Details.contralateralKneeOperationsAt5Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 5-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="ontralateralKneeOperationsAt10Years" checked={type5Details.ontralateralKneeOperationsAt10Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 10-years</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Death, n (%<sup>c</sup>) :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="deathAt2Years" checked={type5Details.deathAt2Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 2-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="deathAt5Years" checked={type5Details.deathAt5Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 5-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="deathAt10Years" checked={type5Details.deathAt10Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 10-years</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Lost to follow-up, n (%<sup>c</sup>) :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="lostToFollowUpAt2Years" checked={type5Details.lostToFollowUpAt2Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 2-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="lostToFollowUpAt5Years" checked={type5Details.lostToFollowUpAt5Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 5-years</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="ostToFollowUpAt10Years" checked={type5Details.lostToFollowUpAt10Years === 1} onChange={(e) => handleInputChange(e, 5)}/>
                            <label className="ms-2" htmlFor="">At 10-years</label>
                          </div>
                        </div>
                        <div className="col-md-2 mt-4 mb-2">
                          {loading5 ? (
                              <div className='save-btn-with-loader'>
                                  <button className="btn blue-btn mt-3 me-2">Save</button>
                                  <div className="spinner-border text-primary mt-3" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                  </div>
                              </div>
                          ):(
                              <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmissionType5}>Save</button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item mb-5">
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#type6" >
                        Patient reported outcome measure (PROM)
                      </button>
                    </h2>
                    <div id="type6" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        <div className="mb-3">
                          <input className="form-check-input" type="checkbox" checked={isAllSelected(type6Details)} onChange={(e) => handleSelectAllChange(e, 6)}/>
                          <label className="ms-2">Select All</label>
                        </div>
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">SANE :</h4>
                        </div>
                        <div className="mb-3 row">
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="sane" checked={type6Details.sane === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">SANE</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="saneAt1yrPostoptTotn" checked={type6Details.saneAt1yrPostoptTotn === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">At 1-year postoperative, total N</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="saneAt2yrPostoptTotn" checked={type6Details.saneAt2yrPostoptTotn === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">At 2-year postoperative, total N</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="saneAt5yrPostoptTotn" checked={type6Details.saneAt5yrPostoptTotn === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">At 5-year postoperative, total N</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="saneAt10yrPostoptTotn" checked={type6Details.saneAt10yrPostoptTotn === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">At 10-year postoperative, total N</label>
                          </div>
                        </div>
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">KOOS subscale, mean (SD) :</h4>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">Preoperative, total N :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscalePreoperativePain" checked={type6Details.koosSubscalePreoperativePain === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Pain</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscalePreoperativeSymptoms" checked={type6Details.koosSubscalePreoperativeSymptoms === 1}  onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Symptoms</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscalePreoperativeActiviDailLiv" checked={type6Details.koosSubscalePreoperativeActiviDailLiv === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Activities of daily living</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscalePreoperativeSportsRecreation" checked={type6Details.koosSubscalePreoperativeSportsRecreation === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Sports/recreation</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscalePreoperativeQualityOfLife" checked={type6Details.koosSubscalePreoperativeQualityOfLife === 1}  onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Quality of life</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label htmlFor="" className="col-form-label">At 1-year postoperative, total N :</label>                      
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscaleAt1YearPostoperativePain" checked={type6Details.koosSubscaleAt1YearPostoperativePain === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Pain</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscaleAt1YearPostoperativeSymptoms" checked={type6Details.koosSubscaleAt1YearPostoperativeSymptoms === 1}  onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Symptoms</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscaleAt1YearPostoperativeActiviDailLiv" checked={type6Details.koosSubscaleAt1YearPostoperativeActiviDailLiv === 1} onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Activities of daily living</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscaleAt1YearPostoperativeSportsRecreation" checked={type6Details.koosSubscaleAt1YearPostoperativeSportsRecreation === 1}  onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Sports/recreation</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox" name="koosSubscaleAt1YearPostoperativeQualityOfLife" checked={type6Details.koosSubscaleAt1YearPostoperativeQualityOfLife === 1}  onChange={(e) => handleInputChange(e, 6)}/>
                            <label className="ms-2" htmlFor="">Quality of life</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label"> At 2-years postoperative, total N : </label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt2YearPostoperativePain"
                              checked={type6Details.koosSubscaleAt2YearPostoperativePain === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Pain</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt2YearPostoperativeSymptoms"
                              checked={type6Details.koosSubscaleAt2YearPostoperativeSymptoms === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Symptoms</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt2YearPostoperativeActiviDailLiv"
                              checked={type6Details.koosSubscaleAt2YearPostoperativeActiviDailLiv === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Activities of daily living</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt2YearPostoperativeSportsRecreation"
                              checked={type6Details.koosSubscaleAt2YearPostoperativeSportsRecreation === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Sports/recreation</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt2YearPostoperativeQualityOfLife"
                              checked={type6Details.koosSubscaleAt2YearPostoperativeQualityOfLife === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Quality of life</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label"> At 5-years postoperative, total N :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt5YearPostoperativePain"
                              checked={type6Details.koosSubscaleAt5YearPostoperativePain === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Pain</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt5YearPostoperativeSymptoms"
                              checked={type6Details.koosSubscaleAt5YearPostoperativeSymptoms === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Symptoms</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt5YearPostoperativeActiviDailLiv"
                              checked={type6Details.koosSubscaleAt5YearPostoperativeActiviDailLiv === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Activities of daily living</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt5YearPostoperativeSportsRecreation"
                              checked={type6Details.koosSubscaleAt5YearPostoperativeSportsRecreation === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Sports/recreation</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt5YearPostoperativeQualityOfLife"
                              checked={type6Details.koosSubscaleAt5YearPostoperativeQualityOfLife === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Quality of life</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">
                            At 10-years postoperative, total N :
                          </label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt10YearPostoperativePain"
                              checked={type6Details.koosSubscaleAt10YearPostoperativePain === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Pain</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt10YearPostoperativeSymptoms"
                              checked={type6Details.koosSubscaleAt10YearPostoperativeSymptoms === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Symptoms</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt10YearPostoperativeActiviDailLiv"
                              checked={type6Details.koosSubscaleAt10YearPostoperativeActiviDailLiv === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Activities of daily living</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt10YearPostoperativeSportsRecreation"
                              checked={type6Details.koosSubscaleAt10YearPostoperativeSportsRecreation === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Sports/recreation</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="koosSubscaleAt10YearPostoperativeQualityOfLife"
                              checked={type6Details.koosSubscaleAt10YearPostoperativeQualityOfLife === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">Quality of life</label>
                          </div>
                        </div>
                        <div className="row">
                          <h4 className="section-sub-heading mt-2">EQ-5D index, mean (SD) :</h4>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">Preoperative, total N :</label>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="eq5dPreoperativeMobility"
                              checked={type6Details.eq5dPreoperativeMobility === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D mobility</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="eq5dPreoperativeSelfCare"
                              checked={type6Details.eq5dPreoperativeSelfCare === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D self-care</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="eq5dPreoperativeUsualActivities"
                              checked={type6Details.eq5dPreoperativeUsualActivities === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D usual activities</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="eq5dPreoperativePainDiscomfort"
                              checked={type6Details.eq5dPreoperativePainDiscomfort === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D pain/discomfort</label>
                          </div>
                          <div className="col-sm-3">
                            <input className="form-check-input" type="checkbox"                              name="eq5dPreoperativeAnxietyDepression"
                              checked={type6Details.eq5dPreoperativeAnxietyDepression === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D anxiety/depression</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">At 1-year postoperative, total N :</label>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt1YearPostoperativeMobility"
                              checked={type6Details.eq5dAt1YearPostoperativeMobility === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D mobility</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt1YearPostoperativeSelfCare"
                              checked={type6Details.eq5dAt1YearPostoperativeSelfCare === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D self-care</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt1YearPostoperativeUsualActivities"
                              checked={type6Details.eq5dAt1YearPostoperativeUsualActivities === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D usual activities</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt1YearPostoperativePainDiscomfort"
                              checked={type6Details.eq5dAt1YearPostoperativePainDiscomfort === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D pain/discomfort</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt1YearPostoperativeAnxietyDepression"
                              checked={type6Details.eq5dAt1YearPostoperativeAnxietyDepression === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D anxiety/depression</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">At 2-years postoperative, total N :</label>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt2YearsPostoperativeMobility"
                              checked={type6Details.eq5dAt2YearsPostoperativeMobility === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D mobility</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt2YearsPostoperativeSelfCare"
                              checked={type6Details.eq5dAt2YearsPostoperativeSelfCare === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D self-care</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt2YearsPostoperativeUsualActivities"
                              checked={type6Details.eq5dAt2YearsPostoperativeUsualActivities === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D usual activities</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt2YearsPostoperativePainDiscomfort"
                              checked={type6Details.eq5dAt2YearsPostoperativePainDiscomfort === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D pain/discomfort</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt2YearsPostoperativeAnxietyDepression"
                              checked={type6Details.eq5dAt2YearsPostoperativeAnxietyDepression === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D anxiety/depression</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">At 5-years postoperative, total N :</label>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt5YearsPostoperativeMobility"
                              checked={type6Details.eq5dAt5YearsPostoperativeMobility === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D mobility</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt5YearsPostoperativeSelfCare"
                              checked={type6Details.eq5dAt5YearsPostoperativeSelfCare === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D self-care</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt5YearsPostoperativeUsualActivities"
                              checked={type6Details.eq5dAt5YearsPostoperativeUsualActivities === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D usual activities</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt5YearsPostoperativePainDiscomfort"
                              checked={type6Details.eq5dAt5YearsPostoperativePainDiscomfort === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D pain/discomfort</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt5YearsPostoperativeAnxietyDepression"
                              checked={type6Details.eq5dAt5YearsPostoperativeAnxietyDepression === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D anxiety/depression</label>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label">At 10-years postoperative, total N :</label>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt10YearsPostoperativeMobility"
                              checked={type6Details.eq5dAt10YearsPostoperativeMobility === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D mobility</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt10YearsPostoperativeSelfCare"
                              checked={type6Details.eq5dAt10YearsPostoperativeSelfCare === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D self-care</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt10YearsPostoperativeUsualActivities"
                              checked={type6Details.eq5dAt10YearsPostoperativeUsualActivities === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D usual activities</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt10YearsPostoperativePainDiscomfort"
                              checked={type6Details.eq5dAt10YearsPostoperativePainDiscomfort === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D pain/discomfort</label>
                          </div>
                          <div className="col-sm-3">
                            <input type="checkbox" className="form-check-input"                              name="eq5dAt10YearsPostoperativeAnxietyDepression"
                              checked={type6Details.eq5dAt10YearsPostoperativeAnxietyDepression === 1}
                              onChange={(e) => handleInputChange(e, 6)}
                            />
                            <label className="ms-2">EQ-5D anxiety/depression</label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-2 mt-4 mb-2">
                            {loading6 ? (
                                <div className='save-btn-with-loader'>
                                    <button className="btn blue-btn mt-3 me-2">Save</button>
                                    <div className="spinner-border text-primary mt-3" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ):(
                                <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmissionType6}>Save</button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>

      <AlertModal
        isOpen={isAlertModalOpen}
        //onClose={() => handleCloseModal()}
        onClose={() => setIsAlertModalOpen(false)}
        title={alertMessage}
        error={alertError}
      />
    </div>
  );
}

export default Setting;


